export default function ($routeSegmentProvider) {
  "ngInject";

  $routeSegmentProvider
    .when('/bike/:id', 'gateway-bike')
    .when('/request/:id', 'gateway-request')

    .segment('gateway-bike', {
      template: '<gateway-bike-page></gateway-bike-page>',
      access: {requireLogin: false},
      loadModule: () => {
        return import(/* webpackChunkName: "gateway-bike.module" */ "./bike/gateway-bike.module");
      }
    })
    .segment('gateway-request', {
      template: '<gateway-request-page></gateway-request-page>',
      access: {requireLogin: false},
      loadModule: () => {
        return import(/* webpackChunkName: "gateway-request.module" */ "./request/gateway-request.module");
      }
    });
}
